import { Skeleton } from 'antd'
import React from 'react'

import './Skeleton.css'

interface Props{
    loading?: boolean
    children?: React.ReactNode
}

const SkeletonCart = ({loading, children}:Props) => {
  return (
    <>
    
    {loading? 
        [1,2,3].map((x, index) => (
            <div key={"Skeleton"+index} className='SkeletonCartComponent'>
            <Skeleton.Image active={true} style={{width:"100%", height:"250px"}} />
            <div className='SkeletonCartTitle'>
            <Skeleton.Button active={true} size={"default"} style={{width:"40%"}}/>
            <Skeleton.Button active={true} size={"default"} style={{width:"40%"}}/>
        
            </div>
            <Skeleton.Input active={true} size={"default"} style={{width:"100%"}} />
            </div>
        ))
    
    

    
    : children
    }

    </>

  )
}

export default SkeletonCart